// Expandable once with fadeout gradient:
// - Only expandable if exceeds given max-height
// - Supports many to many relationships between triggers and containers
//   (this is a special case for the plan table with monthly/annual switches)
// - Must be used together with all the styling classes in expandable_once.scss

// See expandable.js for a more generic, expandable and collapsible component.

const collapsedClass = 'expandable_once--collapsed'
const innerSelector = '.js-expandable_once__inner'

up.compiler('.js-expandable_once', element => {
  if (element.dataset.initialized) {
    return
  }

  element.dataset.initialized = true

  let destructor
  let containerList

  // "expandable group" is a group of elements that can be all expanded by each other's buttons
  // and if one gets expanded, all the others should too
  // this is a very special use case for the plans grid on the publication landing page
  if (element.dataset.expandableGroup) {
    containerList = Array.from(document.querySelectorAll(element.dataset.expandableGroup))
  } else {
    containerList = [element]
  }

  const controlledByList = containerList.reduce(function (acc, container) {
    return [...acc, ...Array.from(document.querySelectorAll(container.dataset.controlledBy))]
  }, [])

  const collapsedHeight = containerList[0].dataset.collapsedHeight
  const initialHeight = Math.max(
    ...containerList.map(function (container) {
      return container.querySelector(innerSelector).getBoundingClientRect().height
    })
  )

  function initContainer(containerList) {
    containerList.forEach(function (container) {
      container.classList.add(collapsedClass)
      container.style.height = `${collapsedHeight}px`
    })
  }

  function initControlledBy(controlledByList, containerList) {
    function expand() {
      const fullHeight = Math.max(
        ...containerList.map(function (container) {
          return container.querySelector(innerSelector).getBoundingClientRect().height
        })
      )

      containerList.forEach(function (container) {
        container.classList.remove(collapsedClass)
        container.style.height = `${fullHeight}px`
      })

      controlledByList.forEach(function (controlledBy) {
        controlledBy.style.display = 'none'
      })
    }

    controlledByList.forEach(function (controlledBy) {
      controlledBy.style.display = 'inline-block'
      controlledBy.addEventListener('click', expand)
    })

    containerList.forEach(function (container) {
      container.addEventListener('focus', expand, true)
    })

    return function () {
      controlledByList.forEach(function (controlledBy) {
        controlledBy.removeEventListener('click', expand)
      })

      containerList.forEach(function (container) {
        container.removeEventListener('focus', expand, true)
      })
    }
  }

  if (initialHeight > collapsedHeight) {
    initContainer(containerList)
    destructor = initControlledBy(controlledByList, containerList)
  }

  return destructor
})
